import { NgModule} from 'ng-metadata/core';
import { MediaContactDocumentComponent } from './media-contact-document.component';
import { MediaContactDocumentAddressComponent } from './address/address.component';
import { MediaContactDocumentDetailsComponent } from './contact-details/contact-details.component';
import { MediaContactDocumentFooterComponent } from './footer/footer.component';
import { MediaContactDocumentHeaderComponent } from './header/header.component';
import { MediaContactDocumentRelevantArticlesComponent } from './relevant-articles/relevant-articles.component';
import { MediaContactDocumentSourceComponent } from './source/source.component';
import { MediaContactDocumentTitleComponent } from './title/title.component';

/**
 * @ngdoc module
 * @name mw.components.mediaContactDocument
 * @description
 *
 */
@NgModule({
    declarations: [
        MediaContactDocumentAddressComponent,
        MediaContactDocumentComponent,
        MediaContactDocumentDetailsComponent,
        MediaContactDocumentFooterComponent,
        MediaContactDocumentHeaderComponent,
        MediaContactDocumentRelevantArticlesComponent,
        MediaContactDocumentSourceComponent,
        MediaContactDocumentTitleComponent
    ]
})
export class MediaContactDocumentModule {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/media-contact-document.module.ts